import axios from "axios";
import cookieStore from "@/utils/store/cookie";
import { buildUploadUrl } from "@/utils/uploadUrl";

const DIRECT_UPLOAD_SIGN_URL = buildUploadUrl("/api/upload/direct/policy");
const DIRECT_UPLOAD_PURPOSE_IMAGE = "image";
const DIRECT_UPLOAD_PURPOSE_COMMITMENT = "commitment";

function getLoginToken() {
  return cookieStore.get("login_status") || "";
}

function resolveSignPayload(response) {
  const payload = response && response.data ? response.data : response;
  if (!payload || typeof payload !== "object") {
    throw new Error("直传签名接口返回异常");
  }
  if (!payload.uploadUrl || !payload.fileUrl) {
    throw new Error("直传签名接口缺少上传参数");
  }
  return payload;
}

export async function requestDirectUploadSignature(
  file,
  purpose = DIRECT_UPLOAD_PURPOSE_IMAGE,
  activityId = null
) {
  const token = getLoginToken();
  if (!token) {
    throw new Error("请先登录后再上传文件");
  }
  const params = {
    fileName: file.name,
    contentType: file.type || "application/octet-stream",
    purpose,
  };
  if (activityId !== null && activityId !== undefined && activityId !== "") {
    params.activityId = activityId;
  }
  const response = await axios.get(DIRECT_UPLOAD_SIGN_URL, {
    params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return resolveSignPayload(response);
}

export async function uploadFileDirectToOss(
  file,
  { onProgress, purpose = DIRECT_UPLOAD_PURPOSE_IMAGE, activityId = null } = {}
) {
  const signPayload = await requestDirectUploadSignature(file, purpose, activityId);
  await axios.put(signPayload.uploadUrl, file, {
    headers: {
      "Content-Type": signPayload.contentType || file.type || "application/octet-stream",
    },
    onUploadProgress(progressEvent) {
      if (typeof onProgress !== "function" || !progressEvent || !progressEvent.total) {
        return;
      }
      onProgress({
        percent: Math.round((progressEvent.loaded / progressEvent.total) * 100),
      });
    },
  });
  return {
    url: signPayload.fileUrl,
    objectKey: signPayload.objectKey || "",
  };
}

export { DIRECT_UPLOAD_PURPOSE_IMAGE, DIRECT_UPLOAD_PURPOSE_COMMITMENT };
